// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_1Miad","foot_link":"index_foot_link_HRS5-","list":"index_list_PJhOL","link":"index_link_QIBuX","copyright":"index_copyright_j5VX6"};